import { FriendsView } from '@/components/social/FriendsView';

export function HomePage() {
  return <FriendsView />;
}
